import { Typography } from "@aviary";

import { subtitle as subtitleStyles } from "./SignUpModalSubtitle.styles";

interface Props {
  subtitle: string;
}

const SignUpModalSubtitle = ({ subtitle }: Props) => {
  return (
    <Typography type="body" css={subtitleStyles}>
      {subtitle}
    </Typography>
  );
};

export { SignUpModalSubtitle };
